var map = {
	"./view/client/client.module": [
		"./src/app/view/client/client.module.ts",
		"common",
		"view-client-client-module"
	],
	"./view/dashboard/dashboard.module": [
		"./src/app/view/dashboard/dashboard.module.ts",
		"view-dashboard-dashboard-module"
	],
	"./view/door/door.module": [
		"./src/app/view/door/door.module.ts",
		"common",
		"view-door-door-module"
	],
	"./view/extra/extra.module": [
		"./src/app/view/extra/extra.module.ts",
		"common",
		"view-extra-extra-module"
	],
	"./view/notification/notification.module": [
		"./src/app/view/notification/notification.module.ts"
	],
	"./view/order/order.module": [
		"./src/app/view/order/order.module.ts",
		"common",
		"view-order-order-module"
	],
	"./view/profile/profile.module": [
		"./src/app/view/profile/profile.module.ts",
		"view-profile-profile-module"
	],
	"./view/session/session.module": [
		"./src/app/view/session/session.module.ts",
		"view-session-session-module"
	],
	"./view/stock/stock.module": [
		"./src/app/view/stock/stock.module.ts",
		"common",
		"view-stock-stock-module"
	],
	"./view/stocktype/stocktype.module": [
		"./src/app/view/stocktype/stocktype.module.ts",
		"common",
		"view-stocktype-stocktype-module"
	],
	"./view/supplier/supplier.module": [
		"./src/app/view/supplier/supplier.module.ts",
		"common",
		"view-supplier-supplier-module"
	],
	"./view/support/support.module": [
		"./src/app/view/support/support.module.ts",
		"view-support-support-module"
	],
	"./view/user/user.module": [
		"./src/app/view/user/user.module.ts",
		"view-user-user-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;